<template>
    <el-row class="fs-site">
      <el-col :span="4" class="fs-close">
        <a @click="$emit('back_page')"><i class="el-icon-back"></i></a>
      </el-col>
      <el-col :span="16" class="fs-entry-header text-center">
        <h1 class="text-title--large">{{ $t('drawer.credit.detail.header') }}</h1>
      </el-col>
      <el-col class="fs-credit-content">
        <el-row class="fs-card mb-2">
          <el-col class="fs-card-img text-right">
            <img :src="'https://images.foodstory.co/' + cardDetail.img">
          </el-col>
          <el-col class="fs-card-number">
            <label class="text-subtitle cl-gray-ligth">{{ $t('drawer.credit.title') }}</label><br>
            <label class="text-heading2">**** ***** ***** {{ cardDetail.number }}</label>
          </el-col>
          <el-col class="">
            <el-row>
              <el-col :span="12" class="mr-2">
                <label class="text-subtitle cl-gray-ligth">{{ $t('drawer.credit.cardname') }}</label><br>
                <label class="text-heading2">{{ cardDetail.name }}</label>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col class="fs-credit-footer">
        <fullButton 
          :bgcolor="'fs-bg-error'" 
          :handleClick="deleteCreditCard" 
          :btn_text="$t('drawer.credit.detail.delete')" 
        />
      </el-col>
      <DialogConfirm/>
    </el-row>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import fullButton from '@/components/element/fullButton'
import DialogConfirm from '@/components/dialog/DialogConfirm'
import Mixins from '@/utils/mixins'

export default {
  name: 'DrawerCreditDetail',
  props: ['cardDetail'],
  components: {
    fullButton,
    DialogConfirm
  },
  mixins: [Mixins],
  data() {
    return {
      deleteCard: false
    }
  },
  methods: {
    deleteCreditCard () {
      this.$store.commit('setConfirmDialog', [true, this.$t('dialog.payment.credit.title2'), this.$t('dialog.payment.credit.description'), 'fs-error'])
    }
  },
  computed: {
    DialogUserConfirm () {
      return this.$store.getters.DialogUserConfirm
    },
    DeleteCard () {
      return this.$store.getters.DeleteCard
    }
  },
  watch:{
    async DialogUserConfirm (value) {
      if (value) {
        await this.$store.dispatch('startLoading')
        this.$store.dispatch('deleteCreditCard', this.cardDetail.uid)
      }
    },
    DeleteCard (value) {
      if (value) {
        this.$store.commit('setDeleteCard', false)
        this.$emit('back_page', 'delete')
      }
    }
  }
};

</script>




// WEBPACK FOOTER //
// src/components/creditcard/DrawerCreditDetail.vue